import type { Immutable } from 'immer';
import { SAVED_VIDEO_STATE, MICRO_VOD_PLAN } from '@studio/constants/library';
import type { Shared } from '@studio/types';

const isSaveOnlyUpgradable = (
  media: Immutable<Shared.Library.BaseMediaItem> | Shared.Library.BaseMediaItem | undefined,
  vodPlanId?: string | null
): boolean => {
  if (!media) return false;
  return (
    (media.state === SAVED_VIDEO_STATE.SAVE_ONLY || media.state === SAVED_VIDEO_STATE.RESOLUTION_UPGRADE_PENDING) &&
    Boolean(vodPlanId) &&
    vodPlanId !== MICRO_VOD_PLAN
  );
};

export default isSaveOnlyUpgradable;
